<div class="w-full bg-white cursor-pointer hover:bg-gray-50 rounded h-10 flex items-center justify-center font-medium text-base">
    <ng-content></ng-content>
</div>
